



























import {Vue, Component} from 'vue-property-decorator';
import $ from 'jquery';
@Component
export default class AuthorityContentTop extends Vue {
  private searchIdInfo: any = '';
  private mounted() {
    this.initDataEmit();
  }
  private initDataEmit = () => {
    let data: any = '';
    this.$emit('initRequest', data);
  };
  private value: string = '';
  private search = () => {
    this.searchIdInfo = $('.searchIdValue').val();
    sessionStorage.setItem('searchVal', this.value);
    this.$emit('initRequest', this.searchIdInfo);
  };
  private handleSearchIdChange() {
    sessionStorage.setItem('searchVal', this.value);
  }
  private reset() {
    this.value = '';
    this.$emit('initRequest', this.searchIdInfo);
  }
}
